import create from 'zustand'
import { persist } from "zustand/middleware"
import steps from "../Steps";
import * as R from "ramda";
import { fetchFromLocalStorage } from "../lib/utils/localStorage";
import { contactsFormState } from "./contactsFormState";
import { informationFormState } from "./informationFormState";
import { usageFormState } from "./usageFormState";
import { extrasFormState } from "./extrasFormState";

const wizardState = set =>  ({
  currentStep: steps[0],
  resetCurrentStep: () => set({ currentStep: steps[0] }),
  setCurrentStep: name => set({ currentStep: name }),
})

const wizardSuccessState = set =>  ({
  successSteps: [],
  resetSuccessSteps: () => set({ successSteps: [] }),
  addSuccessSteps: name => set(state => ({ successSteps: [name, ...state.successSteps] })),
  removeSuccessSteps: name => set(state => ({ successSteps: R.without([name], state.successSteps) })),
})

const stopLoadLangState = set =>  ({
  stopLoadLanguage: null,
  setStopLoadLanguage: lang => set({ stopLoadLanguage: lang }),
})

const alertState = set =>  ({
  alert: null,
  resetAlert: () => set({ alert: null }),
  setAlert: ({ title, body, type= 'warning' }) => set({ alert: { title, body, type }}),
})

const tokenState = set => ({
  token: null,
  tokenFlag: false,
  resetToken: () => set({ token: null }),
  setToken: (value) => set({ token: value }),
  setTokenFlag: (value) => set({ tokenFlag: value }),
})


const useStore = create(persist(
  (set) =>
    ({
      ...wizardState(set),
      ...wizardSuccessState(set),
      ...stopLoadLangState(set),
      ...alertState(set),
      ...contactsFormState(set),
      ...informationFormState(set),
      ...usageFormState(set),
      ...extrasFormState(set),
      ...tokenState(set),
    }),
  {
    name: 'policy-data'
  }
  )
)

const loadInitialState = () => {
  const data = fetchFromLocalStorage('policy-data')
  if(data && data.state) {
    useStore.setState(R.mergeDeepRight(useStore.getState(), data.state))
  }
}

loadInitialState();

export default useStore